import { render, staticRenderFns } from "./news_detail2.vue?vue&type=template&id=6322e4f2&scoped=true&"
import script from "./news_detail2.vue?vue&type=script&lang=js&"
export * from "./news_detail2.vue?vue&type=script&lang=js&"
import style0 from "./news_detail2.vue?vue&type=style&index=0&id=6322e4f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6322e4f2",
  null
  
)

export default component.exports